import useAuthentication from "../Modules/Authentication/Service/hooks/useAuthentication";

const apiUrl = window.location.href.match('js.local') ? "https://zf.local.perfectstate.nl" : "";

export function ResourceLink({ href, children, className = 'btn btn-primary', ...props }) {

    const { getResourceToken } = useAuthentication();

    const onClick = async (e) => {
        e.preventDefault();
        
        try { 
            // Get the resource token first before opening the window
            let resourceTokenQueryString = await getResourceToken();
            let resourceUrl = `${apiUrl}${href}?${resourceTokenQueryString}`;
            
            // Open the window with the complete URL that includes the resource token
            const newWindow = window.open(resourceUrl, '_blank');
            
            // Check if the window was successfully opened
            if (!newWindow) {
                // console.error('Failed to open new window - popup might be blocked');
                // Fallback: try to navigate in the same window
                window.location.href = resourceUrl;
            }
        } catch (error) {
            // console.error('Error getting resource token:', error);
            // Fallback: open the original URL without the token
            const newWindow = window.open(href, '_blank');
            if (!newWindow) {
                window.location.href = href;
            }
        }
    }
    
    return <a href={href} {...props} onClick={onClick} className={className} target="_blank">{children}</a>

}